import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  containerTimeDiagram: {
    "& p": {
      fontSize: "16px",
      fontWeight: 600,
      textAlign: "center",
      marginBottom: "16px",
    },

    "& .MuiPaper-root.MuiTableContainer-root": {
      height: "auto",
    },
  },

  yaxis: {
    width: "max-content"
  },

  containerTable: {
    "&. MuiPaper-root.MuiTableContainer-root": {
      overflowX: "none",
    },
  },

  containerBarChartAndLegend: {
    display: "flex",
    [theme.breakpoints.down(1221)]: {
      flexDirection: "column",
    },
    "& div svg": {
      margin: 0,
    },
    "& div svg defs clipPath rect": {
      borderBottom: "1px solid red",
    },
    "& svg g:nth-child(5) g g path": {
      clipPath: "inset(0% 0% -100% 0% round 10px)",
      [theme.breakpoints.down(801)]: {
        clipPath: "inset(0% 0% -100% 0% round 5px)",
      },
    },
    "& svg g:nth-child(6) g g path": {
      clipPath: "inset(0% 0% -100% 0% round 10px)",
      [theme.breakpoints.down(801)]: {
        clipPath: "inset(0% 0% -100% 0% round 5px)",
      },
    },
    "& svg g:nth-child(7) g g path": {
      clipPath: "inset(0% 0% -100% 0% round 10px)",
      [theme.breakpoints.down(801)]: {
        clipPath: "inset(0% 0% -100% 0% round 5px)",
      },
    },
  },

  title: {
      paddingLeft: "10%",
      maxWidth: "600px",
      [theme.breakpoints.down(1831)]: {
        maxWidth: "500px",
      },
      [theme.breakpoints.down(1681)]: {
        maxWidth: "400px",
      },
      [theme.breakpoints.down(1401)]: {
        maxWidth: "300px",
      },
      [theme.breakpoints.down(1221)]: {
        maxWidth: "700px",
      },
      [theme.breakpoints.down(1081)]: {
        maxWidth: "600px",
      },
      [theme.breakpoints.down(981)]: {
        maxWidth: "500px",
      },
      [theme.breakpoints.down(881)]: {
        maxWidth: "400px",
      },
      [theme.breakpoints.down(791)]: {
        paddingLeft: "15%",
      },
  },

  information: {
    width: "190px",
    marginLeft: "16px",
    [theme.breakpoints.down(1221)]: {
      order: "-1",
      marginLeft: 7,
      width: "auto",
    },
    "& div": {
      position: "initial !important",
      height: "100% !important",
      marginBottom: "16px",
    },
  },

  barChart: {
    margin: "0 auto",
  },

  tooltip: {
    width: "auto",
    maxHeight: "106px",
  },

  rechartsDefaultLegend: {
    position: "relative",
  },

  ulContainer: {
    padding: 0,
    margin: "0",
    textAlign: "center",
    lineHeight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: "190px",
    height: "100%",
    [theme.breakpoints.down(1221)]: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "start",
      gap: "8px",
    },
  },

  liContent: {
    display: "flex",
    flexWrap: "nowrap",
    fontSize: "10px",
    fontWeight: "bold",
    margin: 0,
    justifyContent: "space-between",
    alignItems: "center",
  },

  rechartSurface: {
    width: "20px",
    height: "20px",
    display: "inline-block",
    verticalAlign: "middle",
    borderRadius: "100%",
    [theme.breakpoints.down(1221)]: {
      width: "12px",
      height: "12px",
      marginLeft: "2px !important",
    },
  },


  dialog: {
    '& .MuiPaper-root.MuiTableContainer-root': {
      width: "100%"
    }
  }


}));

export default useStyles;
